import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import AdminRoute from '../components/auth/AdminRoute';

// Public Pages
import Login from '../pages/Login';
import Signup from '../pages/Signup';
import EmailVerification from '../pages/EmailVerification';
import AuthCallback from '../components/auth/authCallback';

// Protected Pages
import Dashboard from '../pages/Dashboard';
import SecurityCenter from '../pages/SecurityCenter';
import Analytics from '../pages/Analytics';
import Settings from '../pages/Settings';

// Admin Pages
import AdminLayout from '../pages/Admin';
import UsersManagement from '../pages/Admin/Users';
import DomainSettings from '../pages/Admin/domain';
import OrganizationSettings from '../pages/Admin/organization';
import BillingPage from '../pages/Admin/billing';  

export default function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      
      {/* Email Verification - COMPLETELY STANDALONE */}
      <Route path="/verify/:scode" element={<EmailVerification />} />
      
      {/* Protected Routes with Layout */}
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        {/* Default redirect */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        
        {/* Main app routes */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/security" element={<SecurityCenter />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/settings" element={<Settings />} />
        
        {/* Admin Section */}
        <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
          <Route index element={<Navigate to="users" replace />} />
          <Route path="users" element={<UsersManagement />} />
          <Route path="organization" element={<OrganizationSettings />} />
          <Route path="domain" element={<DomainSettings />} />
          <Route path="billing" element={<BillingPage />} />  
        </Route>
      </Route>

      {/* Catch All Route */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}